import { type FC } from "react";
import { Autocomplete, TextField } from "@mui/material";

interface UtmFieldProps {
  dimension: "SOURCE" | "MEDIUM" | "CAMPAIGN" | "CONTENT" | "TERM";
  label: string;
  value: string[];
  onChange: (values: string[]) => void;
}

// Свободный текстовый мультиселект, не автокомплит по сущностям — значения
// UTM произвольные строки, задаваемые при создании маркетинговых ссылок
// (links domain), справочника всех использованных значений в этой кодовой
// базе нет. `dimension` не используется внутри поля — оставлен в пропсах
// только для единообразия вызова в Filter.tsx (Task 18) и для возможного
// будущего автокомплита по фактически встречавшимся значениям конкретного
// UTM-параметра.
export const UtmField: FC<UtmFieldProps> = ({ label, value, onChange }) => (
  <Autocomplete<string, true, false, true>
    multiple
    freeSolo
    fullWidth
    options={[]}
    value={value}
    onChange={(_event, newValue) => onChange(newValue as string[])}
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);
